import 'bootstrap/dist/css/bootstrap.css'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const globalDiv = document.getElementById('root')
const root = globalDiv ? ReactDOM.createRoot(globalDiv) : null
root?.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
